import InfoBox, { InfoBoxType } from 'flow/components/ui-components/InfoBox';
import useAppContext from 'flow/hooks/useAppContext';
import React from 'react';

const VOICE_MESSAGES_MAXIMUM_AMOUNT = 99;
const VOICE_MESSAGES_NOTIFY_THRESHOLD = 79;

interface Props {
    total: number;
}

const VoiceMessageBanner = ({ total }: Props) => {
    const { i18next } = useAppContext();

    if (total < VOICE_MESSAGES_NOTIFY_THRESHOLD) {
        return null;
    }

    if (total < VOICE_MESSAGES_MAXIMUM_AMOUNT) {
        return (
            <InfoBox type={InfoBoxType.Warning}>
                {i18next.t('shared.voicemail.threshold.warning', {
                    amount: total,
                    limit: VOICE_MESSAGES_MAXIMUM_AMOUNT,
                })}
            </InfoBox>
        );
    }

    return (
        <InfoBox type={InfoBoxType.Alert}>
            {i18next.t('shared.voicemail.full.warning', {
                limit: VOICE_MESSAGES_MAXIMUM_AMOUNT,
            })}
        </InfoBox>
    );
};

export default VoiceMessageBanner;
